import * as React from "react";
import * as Lightbox from "react-image-lightbox";
import type { IScope } from "reducers/scope";
import DownloadIcon from "components/icons/download";
import { rawTheme } from "styles/theme";
import config from "site-config";

interface IProps {
    item: any;
    onClose: () => void;
    open: boolean;
    scope?: IScope;
    fullWidth: boolean;
    initialIndex?: number;
    onIndexChange?: (n: number) => void;
    noDownloads?: boolean;
}

const noop = (n: number) => undefined;

interface IState {
    index: number;
}

const styles = {
    modal: {
        content: {
            marginRight: "323px",
        },
        overlay: {
            zIndex: 10000,
        },
    },
    modalMobile: {
        overlay: {
            zIndex: 10000,
        },
    },
};

export default class ProductImagesLightbox extends React.PureComponent<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            index: props.initialIndex || 0,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // Reset if new item is loaded
        if (nextProps.item !== this.props.item || (nextProps.open && !this.props.open)) {
            this.setState({ index: nextProps.initialIndex || 0 });
        }
    }

    render() {
        if (!this.props.open) {
            return null;
        }
        const { fullWidth, item, scope, noDownloads } = this.props;
        const { index } = this.state;
        const imagesAndSwatches = this.isItemARecord(item) ? item.getImagesAndSwatch(scope, "") : item.__images;

        const imageLength = imagesAndSwatches ? imagesAndSwatches.length : 1;
        const nextIndex = (index + 1) % imageLength;
        const prevIndex = (index + imageLength - 1) % imageLength;

        const swatchValue = this.getValuefromUrl(imagesAndSwatches[index]);
        const downloadUrl =
            this.parsePathUrl(imagesAndSwatches[index]) === "brand_color_swatch"
                ? `${config.api}/api/v3.0/brand_color_swatch/${swatchValue}`
                : `${config.api}/api/v3.0/item/image/${item.__images[index]}`;

        let mainSrcImage;
        if (item.swatch_type || (item.countMediaImages && !item.countMediaImages(scope))) {
            mainSrcImage = item.value
                ? `//cdn1.nuorder.com/brand_color_swatch/${item.value}.jpg`
                : imagesAndSwatches[index];
        } else {
            mainSrcImage = item.getImageSrc(index, "", scope);
        }

        const downloadButtonStyle = {
            height: "50px",
            width: "40px",
            padding: "0px 7px",
            position: "relative" as "relative",
            top: "9px",
        };

        const downloadButton = [
            <a key="download" style={downloadButtonStyle} href={downloadUrl}>
                <DownloadIcon color={rawTheme.palette.grey} hoverColor={rawTheme.palette.canvasColor} />
            </a>,
        ];

        return (
            <div onClick={this.handlePreventBubbling}>
                <Lightbox
                    reactModalStyle={fullWidth ? styles.modalMobile : styles.modal}
                    mainSrc={mainSrcImage}
                    nextSrc={imageLength > 1 ? imagesAndSwatches[nextIndex] : undefined}
                    prevSrc={imageLength > 1 ? imagesAndSwatches[prevIndex] : undefined}
                    onCloseRequest={this.props.onClose}
                    onMovePrevRequest={this.handleLightboxPrev}
                    onMoveNextRequest={this.handleLightboxNext}
                    toolbarButtons={noDownloads ? [] : downloadButton}
                />
            </div>
        );
    }

    private handleLightboxPrev = () => {
        const { scope, item, onIndexChange = noop } = this.props;
        const totalImages = this.isItemARecord(item) ? item.getImagesAndSwatch(scope, "") : item.__images;
        const index = (this.state.index + totalImages.length - 1) % totalImages.length;
        onIndexChange(index);
        this.setState({ index });
    };

    private isItemARecord = (item) => {
        return typeof item.getImagesAndSwatch !== "undefined";
    };

    private parsePathUrl = (srcUrl) => {
        const firstSplit = srcUrl.split("/");
        return firstSplit[3];
    };

    private getValuefromUrl = (srcUrl) => {
        const firstSplit = srcUrl.split("/");
        const secondSplit = firstSplit[4].split(".");
        return secondSplit[0];
    };

    private handleLightboxNext = () => {
        const { scope, item, onIndexChange = noop } = this.props;
        const totalImages = this.isItemARecord(item) ? item.getImagesAndSwatch(scope, "") : item.__images;
        const index = (this.state.index + 1) % totalImages.length;
        onIndexChange(index);
        this.setState({ index });
    };

    private handlePreventBubbling = (e) => {
        e.stopPropagation();
    };
}
